import React from "react";
import DataTable from "react-data-table-component";

function DataTableDisplay({ data, columns }) {


  const customStyles = {
    table: {
      style: {
        border: "1px solid var(--Grays-Gray-5, #E5E5EA)",
      },
    },
    headCells: {
      style: {
        color: "#545252",
        backgroundColor: "#fafafa",
        borderBottom: "1px solid var(--Grays-Gray-5, #E5E5EA)",
      },
    },
  };

  return (
    <div>
      <DataTable
        defaultSortFieldId={null}
        persistTableSort={false}
        className="dataTableClass"
        columns={columns}
        data={data ?? []}
        pagination
        customStyles={customStyles}
        paginationComponentOptions={{
          noRowsPerPage: true,
        }}
      />
    </div>
  );
}

export default DataTableDisplay;
